import type { FC, ReactNode } from 'react'

import { Phone, Plus } from 'lucide-react'
import { buttonClass } from '@/lib/button'
import SectionHeading from '@/components/landing/section-heading'

import { contactPhones, faqs } from '@/constants/content'

const FaqSection: FC = (): ReactNode => {
    const primaryPhone = contactPhones[0]

    return (
        <section id='faq' aria-labelledby='faq-title' className='scroll-mt-20 bg-white py-20 sm:py-24 lg:py-28'>
            <div className='mx-auto grid max-w-7xl gap-12 px-5 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:px-8'>
                <div className='lg:sticky lg:top-28 lg:self-start'>
                    <SectionHeading
                        id='faq-title'
                        eyebrow="FAQ"
                        title="Questions students ask us."
                        description="Can't find your answer here? Call the team and we'll help you out."
                    />

                    <a href={primaryPhone.href} className={buttonClass('outline', 'md', 'mt-8')}>
                        <Phone className='size-4 text-primary' aria-hidden='true' />
                        Call {primaryPhone.display}
                    </a>
                </div>

                <div className='divide-y divide-border overflow-hidden rounded-2xl border border-border bg-card'>
                    {faqs.map((faq, index) => (
                        <details key={faq.question} className='group' open={index === 0}>
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-6 px-6 py-5 text-left text-base font-semibold text-foreground transition-colors hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/40 [&::-webkit-details-marker]:hidden'>
                                {faq.question}

                                <span className='flex size-8 shrink-0 items-center justify-center rounded-full bg-secondary text-primary transition-transform duration-300 group-open:rotate-45'>
                                    <Plus className='size-4' aria-hidden='true' />
                                </span>
                            </summary>

                            <p className='px-6 pb-6 text-[15px] leading-relaxed text-muted-foreground'>
                                {faq.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FaqSection
